import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class PeripheralsService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createPeripheral(peripheral): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(peripheral);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/peripheral"}`;
    return this.http.post(url, data, { headers });
  }

  updatePeripheral(peripheral): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(peripheral);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/peripheral"}/${
      peripheral?.code
    }`;
    return this.http.put(url, data, { headers });
  }
}
